// add missing `globalThis` variable for old browsers in Android 8.0 platform
try {
  (window.globalThis as any) = window;
} catch {}

export {};
